import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import DocSelector from './diffing/doc-selector';
import R from 'ramda';
import injectSheet from 'react-jss';
import { replace as replaceAction } from 'react-router-redux';

const propTypes = {
  allTemplates: PropTypes.array,
  replace: PropTypes.func,
  params: PropTypes.object,
  availDocs: PropTypes.array,
  loadingDocs: PropTypes.bool,
};
const styles = {
  container: { marginTop: '40px' },
  selectionContainer: {
    width: '80%',
    margin: '60px auto 0',
    display: 'flex',
    alignItems: 'flex-start'
  },
  compareDocContainer: {
    width: '40%',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  baseDocContainer: {
    width: '40%',
    marginLeft: '20%',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  }
};
class SelectDocsForDiffReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { classes, availDocs = [], params, location, loadingDocs } = this.props;
    const {
      container,
      selectionContainer,
      compareDocContainer,
      baseDocContainer,
    } = classes;
    const collection = params.collection;
    const baseId = params.baseId;
    const { locationName, companyName } = location.query;
    return (
      <div className={container}>
        <h4 style={{ textAlign: 'center' }}>{companyName ? `${companyName} - ` : ''}{locationName}</h4>
        <div className={selectionContainer}>
          <div className={compareDocContainer}>Compare with</div>
          <div className={baseDocContainer}>
            Base {collection === 'template' ? 'Template' : 'Contract'}
          </div>
        </div>
        <DocSelector
          availDocs={availDocs}
          initialBaseDocId={baseId}
          collection={collection}
          loadingDocs={loadingDocs}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ contractingReports }) => ({
  ...contractingReports.get('diff'),
});

const mapDispatchToProps = ({
  replace: replaceAction
});
SelectDocsForDiffReport.propTypes = propTypes;
SelectDocsForDiffReport.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(SelectDocsForDiffReport));




// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/select-docs-page.jsx